import { NotificationType } from '../enums';

import { Notifications } from '../notifications.class';

export const getStateCfn = (notifications: Notifications): NotificationType => {
	const notificationCounts = notifications.getCounts();

	return notificationCounts.critical > 0
		? NotificationType.Critical
		: notificationCounts.error > 0
			? NotificationType.Error
			: notificationCounts.warn > 0
				? NotificationType.Warn
				: notificationCounts.info > 0
					? NotificationType.Info
					: NotificationType.None;
}
